import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { registerEnrolmentNavigator, registerStepUpPrompter, type StepUpRequest } from "../../../lib/http/stepup";
import StepUpForm from "./StepUpForm";

const { Paragraph } = Typography;

// Mounted once inside the router: answers the shared client's step-up prompts and enrolment redirects (contract §6.10).
const StepUpHost: React.FC = () => {
	const navigate = useNavigate();
	const [request, setRequest] = useState<StepUpRequest | null>(null);
	const resolver = useRef<((steppedUp: boolean) => void) | null>(null);

	useEffect(
		() =>
			registerStepUpPrompter(
				(next) =>
					new Promise<boolean>((resolve) => {
						resolver.current = resolve;
						setRequest(next);
					})
			),
		[]
	);

	useEffect(() => registerEnrolmentNavigator((path) => navigate(path)), [navigate]);

	const settle = useCallback((steppedUp: boolean) => {
		resolver.current?.(steppedUp);
		resolver.current = null;
		setRequest(null);
	}, []);

	// An unmount mid-prompt must not leave the refused request hanging.
	useEffect(() => () => resolver.current?.(false), []);

	return (
		<Modal
			title="Confirm it's you"
			open={request !== null}
			onCancel={() => settle(false)}
			footer={null}
			maskClosable={false}
			destroyOnClose
			width={440}
		>
			{request && (
				<StepUpForm
					methods={request.methods}
					onSuccess={() => settle(true)}
					onCancel={() => settle(false)}
					intro={<Paragraph type="secondary">This action needs a fresh check with your authenticator app or passkey.</Paragraph>}
				/>
			)}
		</Modal>
	);
};

export default StepUpHost;
